import { AppBar, Toolbar, Typography, IconButton, Box, Container, Drawer, List, ListItem, useMediaQuery, useTheme } from '@mui/material';
import { Link, useLocation } from "react-router-dom";
import '../styles/Navbar.css';
import { useAuth } from "react-oidc-context";
// import { useContext } from "react";
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import UserIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import MapIcon from '@mui/icons-material/Map';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useState, useMemo, useEffect } from 'react';
import logoMaps from '../assets/icons/Logo_Komoks_Maps.png'
import logo from '../assets/icons/Logo_Komoks.png'
import { useSelector, useDispatch } from 'react-redux';
import { toggleDarkMode } from '../store/reducers/stateReducer';

const NavBar = () => {
    const auth = useAuth()
    // const { userPayload, setUserPayload } = useContext(UserContext)
    // const { isAuth } = userPayload
    // const navigate = useNavigate()
    const dispatch = useDispatch();
    const user = useSelector(state => state.state.user)
    const darkMode = useSelector(state => state.state.darkMode)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();
    const [pageTitle, setPageTitle] = useState('');
    const [pageIcon, setPageIcon] = useState(null);

    useEffect(() => {
        switch (location.pathname) {
            case '/an':
                setPageTitle('Авторский надзор');
                setPageIcon(<img style={{ width: '40px' }} src={logoMaps}></img>);
                break;
            case '/accountings':
                setPageTitle('Замечения');
                setPageIcon(<img style={{ width: '32px' }} src={logo}></img>);
                break;
            case '/tasks':
                setPageTitle('Задачи');
                setPageIcon(<img style={{ width: '32px' }} src={logo}></img>);
                break;
            case '/management':
                setPageTitle('Настройки');
                setPageIcon(<img style={{ width: '32px' }} src={logo}></img>);
                break;
            case '/objects_reestr':
                setPageTitle('Реестр объектов');
                setPageIcon(
                    <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#8baa64">
                        <path d="M320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Zm240 240q-17 0-28.5-11.5T520-600q0-17 11.5-28.5T560-640q17 0 28.5 11.5T600-600q0 17-11.5 28.5T560-560Zm0 200q81-69 120.5-127.5T720-596q0-75-48.5-119.5T560-760q-63 0-111.5 44.5T400-596q0 50 39.5 108.5T560-360Z"
                        />
                    </svg>
                    // <img style={{ width: '32px', marginRight: '10px' }} src={logo}></img>
                );
                break;
            case '/field_works':
                setPageTitle('Лог полевых работ');
                setPageIcon(<img style={{ width: '32px' }} src={logo}></img>);
                break;
            default:
                setPageTitle('Авторский надзор');
                setPageIcon(<img style={{ width: '40px', marginRight: '10px' }} src={logoMaps}></img>);
        }
    }, [location.pathname]);

    const isAdmin = useMemo(() => {
        return user.roles.includes('admin')
    }, [user])
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const logout = () => {
        // localStorage.clear()
        // setUserPayload({ user: null, isAdmin: null, isAuth: null })
        // navigate('/login', { replace: true })
        auth.removeUser()
        auth.signoutRedirect()
    }

    const handleToggleDarkMode = () => {
        dispatch(toggleDarkMode());
    }

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <List>
                {auth.isAuthenticated && (
                    <ListItem sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
                        <UserIcon />
                        <Typography variant="body1">
                            <b>{auth.user.profile.given_name}</b>
                        </Typography>
                    </ListItem>
                )}
                {auth.isAuthenticated && (
                    <ListItem sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
                        <IconButton
                            component={Link}
                            to="/"
                            color="inherit"
                            sx={{ p: 0 }}
                        >
                            <HomeIcon />
                            <Typography variant="body1">
                                Домашняя страница
                            </Typography>
                        </IconButton>
                    </ListItem>
                )}
                {auth.isAuthenticated && isAdmin && (
                    <ListItem sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
                        <IconButton
                            component={Link}
                            to="/management"
                            color="inherit"
                            sx={{ p: 0 }}
                        >
                            <AdminPanelSettingsIcon />
                            <Typography variant="body1">
                                Управление
                            </Typography>
                        </IconButton>
                    </ListItem>
                )}
                {auth.isAuthenticated && (
                    <ListItem sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
                        <IconButton
                            onClick={handleToggleDarkMode}
                            color="inherit"
                            sx={{ p: 0 }}
                        >
                            {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
                            <Typography variant="body1" sx={{ ml: 1 }}>
                                {darkMode ? 'Светлая тема' : 'Темная тема'}
                            </Typography>
                        </IconButton>
                    </ListItem>
                )}
                {auth.isAuthenticated && (
                    <ListItem sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
                        <IconButton
                            component={Link}
                            onClick={logout}
                            color="inherit"
                            sx={{ p: 0 }}
                        >
                            <LogoutIcon />
                            <Typography variant="body1">
                                Выйти
                            </Typography>
                        </IconButton>

                    </ListItem>
                )}
            </List>
        </Box>
    );

    return (
        <AppBar
            position={"static"}
            style={{
                background: 'linear-gradient(135deg, #2c3e50 0%, #4a6741 100%)',
                backgroundColor: '#2c3e50'
            }}
            sx={{ zIndex: 1300 }}
        >
            <Container maxWidth={false}>
                <Toolbar disableGutters style={{ minHeight: isMobile ? '34px' : '42px' }}>
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {pageIcon}
                        <Typography
                            variant="h6"
                            component={Link}
                            to="/"
                            sx={{
                                textDecoration: 'none',
                                color: 'inherit',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: isMobile ? '14px' : '18px',
                                lineHeight: '1.2'
                            }}
                        >
                            {pageTitle}
                        </Typography>
                    </Box>

                    {!isMobile && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {/* {isAdmin && isAdmin ?
                <Nav.Link as={Link} to='adm'>Пользователи</Nav.Link>
              :
                null
              } */}
                            {auth.isAuthenticated && (
                                <Typography sx={{ mr: 2 }}>
                                    <b>{auth.user.profile.given_name}</b>
                                </Typography>
                            )}
                            {auth.isAuthenticated && (
                                <IconButton
                                    component={Link}
                                    to="/"
                                    color="inherit"
                                    sx={{ mr: 1 }}
                                >
                                    <HomeIcon />
                                </IconButton>
                            )}
                            {auth.isAuthenticated && isAdmin && (
                                <IconButton
                                    component={Link}
                                    to="/management"
                                    color="inherit"
                                    sx={{ mr: 1 }}
                                >
                                    <AdminPanelSettingsIcon />
                                </IconButton>
                            )}
                            {auth.isAuthenticated && (
                                <IconButton
                                    onClick={handleToggleDarkMode}
                                    color="inherit"
                                    sx={{ mr: 1 }}
                                    title={darkMode ? 'Переключить на светлую тему' : 'Переключить на темную тему'}
                                >
                                    {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
                                </IconButton>
                            )}
                            {auth.isAuthenticated && (

                                <IconButton
                                    component={Link}
                                    onClick={logout}
                                    color="inherit"
                                    sx={{ ml: 1 }}
                                >
                                    <LogoutIcon />
                                </IconButton>
                            )}
                        </Box>
                    )}

                    {isMobile && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ ml: 1 }}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                </Toolbar>
            </Container>

            <Drawer
                variant="temporary"
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}

                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
                    zIndex: 10000,
                }}
            >
                {drawer}
            </Drawer>
        </AppBar>
    );
}

export default NavBar;
